export default __webpack_public_path__ + "static/media/scenezen.07d2d26f.png";